export const containers = [
    {
        id: 'container_1',
        name: 'GreenFrame Browser',
        type: 'DEVICE',
        score: {
            s: {
                cpu: 0.20550000000000004,
                screen: 12.7975,
                totalTime: 45.93849999999999,
            },
            gb: {
                mem: 0.7338639360000001,
                disk: 0,
                network: 0.0018178884999999994,
            },
            wh: {
                cpu: 0.006,
                mem: 0,
                disk: 0,
                total: 0.054,
                screen: 0.036,
                network: 0.012,
            },
            co2: {
                total: 0.023,
            },
        },
        stats: [
            {
                n: 2,
                io: {
                    totalBytes: 0,
                    currentBytes: 0,
                },
                cpu: {
                    cpuPercentage: 0,
                    totalUsageInUserMode: 0,
                    currentUsageInUserMode: 0,
                    totalUsageInKernelMode: 0,
                    availableSystemCpuUsage: 0,
                    currentUsageInKernelMode: 0,
                },
                date: '2022-01-19T14:25:40.312Z',
                time: 1.004,
                active: false,
                memory: {
                    usage: 0,
                },
                network: {
                    totalReceived: 0,
                    currentReceived: 0,
                    totalTransmitted: 0,
                    currentTransmitted: 0,
                },
                userTime: 0,
            },
            {
                n: 2,
                io: {
                    totalBytes: 0,
                    currentBytes: 0,
                },
                cpu: {
                    cpuPercentage: 0,
                    totalUsageInUserMode: 0,
                    currentUsageInUserMode: 0,
                    totalUsageInKernelMode: 0,
                    availableSystemCpuUsage: 0,
                    currentUsageInKernelMode: 0,
                },
                date: '2022-01-19T14:25:41.317Z',
                time: 2.008,
                active: false,
                memory: {
                    usage: 0,
                },
                network: {
                    totalReceived: 0,
                    currentReceived: 0,
                    totalTransmitted: 0,
                    currentTransmitted: 0,
                },
                userTime: 0,
            },
            {
                n: 2,
                io: {
                    totalBytes: 49152,
                    currentBytes: 49053.89221556886,
                },
                cpu: {
                    cpuPercentage: 5.7450495049504955,
                    totalUsageInUserMode: 0.057499999999999996,
                    currentUsageInUserMode: 0.0572808566134663,
                    totalUsageInKernelMode: 0.0225,
                    availableSystemCpuUsage: 1.001999984095554,
                    currentUsageInKernelMode: 0.022410358565737053,
                },
                date: '2022-01-19T14:25:42.319Z',
                time: 3.0109999999999997,
                active: true,
                memory: {
                    usage: 96626688,
                },
                network: {
                    totalReceived: 487942,
                    currentReceived: 486004.3230272523,
                    totalTransmitted: 8757,
                    currentTransmitted: 8723.929630778284,
                },
                userTime: 0.42400000000000004,
                timeframe: {
                    end: '2022-01-19T14:25:51.178Z',
                    start: '2022-01-19T14:25:42.016Z',
                },
            },
            {
                n: 2,
                io: {
                    totalBytes: 49152,
                    currentBytes: 0,
                },
                cpu: {
                    cpuPercentage: 31.244606872747575,
                    totalUsageInUserMode: 0.3675,
                    currentUsageInUserMode: 0.3085915046282532,
                    totalUsageInKernelMode: 0.1,
                    availableSystemCpuUsage: 0.9880552417196885,
                    currentUsageInKernelMode: 0.07715654793760283,
                },
                date: '2022-01-19T14:25:43.323Z',
                time: 4.015499999999999,
                active: true,
                memory: {
                    usage: 137875456,
                },
                network: {
                    totalReceived: 1235654.5,
                    currentReceived: 744533.5592951578,
                    totalTransmitted: 38437.5,
                    currentTransmitted: 29547.718082892316,
                },
                userTime: 1.4284999999999999,
                timeframe: {
                    end: '2022-01-19T14:25:51.178Z',
                    start: '2022-01-19T14:25:42.016Z',
                },
            },
            {
                n: 2,
                io: {
                    totalBytes: 49152,
                    currentBytes: 0,
                },
                cpu: {
                    cpuPercentage: 17.20607990447286,
                    totalUsageInUserMode: 0.54,
                    currentUsageInUserMode: 0.17181274900398408,
                    totalUsageInKernelMode: 0.135,
                    availableSystemCpuUsage: 0.9985059760956175,
                    currentUsageInKernelMode: 0.0348605577689243,
                },
                date: '2022-01-19T14:25:44.327Z',
                time: 5.0195,
                active: true,
                memory: {
                    usage: 168421376,
                },
                network: {
                    totalReceived: 1372257.5,
                    currentReceived: 136058.76494023902,
                    totalTransmitted: 44808,
                    currentTransmitted: 6345.11952191235,
                },
                userTime: 2.4325,
                timeframe: {
                    end: '2022-01-19T14:25:51.178Z',
                    start: '2022-01-19T14:25:42.016Z',
                },
            },
            {
                n: 2,
                io: {
                    totalBytes: 49152,
                    currentBytes: 0,
                },
                cpu: {
                    cpuPercentage: 12.20995176440721,
                    totalUsageInUserMode: 0.66,
                    currentUsageInUserMode: 0.11964107676969093,
                    totalUsageInKernelMode: 0.1525,
                    availableSystemCpuUsage: 0.9895314057826521,
                    currentUsageInKernelMode: 0.017447657028913263,
                },
                date: '2022-01-19T14:25:45.330Z',
                time: 6.0225,
                active: true,
                memory: {
                    usage: 177692672,
                },
                network: {
                    totalReceived: 1491495.5,
                    currentReceived: 118881.3559322034,
                    totalTransmitted: 50500.5,
                    currentTransmitted: 5675.473579262214,
                },
                userTime: 3.4354999999999998,
                timeframe: {
                    end: '2022-01-19T14:25:51.178Z',
                    start: '2022-01-19T14:25:42.016Z',
                },
            },
            {
                n: 2,
                io: {
                    totalBytes: 49152,
                    currentBytes: 0,
                },
                cpu: {
                    cpuPercentage: 24.23606573855355,
                    totalUsageInUserMode: 0.9025,
                    currentUsageInUserMode: 0.24153386454183268,
                    totalUsageInKernelMode: 0.20500000000000002,
                    availableSystemCpuUsage: 0.9935258964143426,
                    currentUsageInKernelMode: 0.05229083665338645,
                },
                date: '2022-01-19T14:25:46.334Z',
                time: 7.0264999999999995,
                active: true,
                memory: {
                    usage: 203620352,
                },
                network: {
                    totalReceived: 1574396,
                    currentReceived: 82570.21912350597,
                    totalTransmitted: 68145,
                    currentTransmitted: 17574.203187250998,
                },
                userTime: 4.4395,
                timeframe: {
                    end: '2022-01-19T14:25:51.178Z',
                    start: '2022-01-19T14:25:42.016Z',
                },
            },
            {
                n: 2,
                io: {
                    totalBytes: 49152,
                    currentBytes: 0,
                },
                cpu: {
                    cpuPercentage: 12.222884077488864,
                    totalUsageInUserMode: 1.0225,
                    currentUsageInUserMode: 0.11944510515153318,
                    totalUsageInKernelMode: 0.225,
                    availableSystemCpuUsage: 0.9781000376603042,
                    currentUsageInKernelMode: 0.019907930467185985,
                },
                date: '2022-01-19T14:25:47.339Z',
                time: 8.030999999999999,
                active: true,
                memory: {
                    usage: 209094656,
                },
                network: {
                    totalReceived: 1847419,
                    currentReceived: 271813.74155120814,
                    totalTransmitted: 79770,
                    currentTransmitted: 11571.89649362748,
                },
                userTime: 5.443999999999999,
                timeframe: {
                    end: '2022-01-19T14:25:51.178Z',
                    start: '2022-01-19T14:25:42.016Z',
                },
            },
            {
                n: 2,
                io: {
                    totalBytes: 49152,
                    currentBytes: 0,
                },
                cpu: {
                    cpuPercentage: 23.357223782079704,
                    totalUsageInUserMode: 1.2574999999999998,
                    currentUsageInUserMode: 0.23280517888879698,
                    totalUsageInKernelMode: 0.2725,
                    availableSystemCpuUsage: 1.0000206887583198,
                    currentUsageInKernelMode: 0.04701766622924722,
                },
                date: '2022-01-19T14:25:48.350Z',
                time: 9.038499999999999,
                active: true,
                memory: {
                    usage: 222150656,
                },
                network: {
                    totalReceived: 1980644.5,
                    currentReceived: 131820.75555345387,
                    totalTransmitted: 101388,
                    currentTransmitted: 21405.27110154831,
                },
                userTime: 6.451499999999999,
                timeframe: {
                    end: '2022-01-19T14:25:51.178Z',
                    start: '2022-01-19T14:25:42.016Z',
                },
            },
            {
                n: 2,
                io: {
                    totalBytes: 49152,
                    currentBytes: 0,
                },
                cpu: {
                    cpuPercentage: 14.185138892431702,
                    totalUsageInUserMode: 1.3975,
                    currentUsageInUserMode: 0.13952669355118727,
                    totalUsageInKernelMode: 0.2975,
                    availableSystemCpuUsage: 0.9860517948641638,
                    currentUsageInKernelMode: 0.024915303839724613,
                },
                date: '2022-01-19T14:25:49.355Z',
                time: 10.042499999999999,
                active: true,
                memory: {
                    usage: 227553280,
                },
                network: {
                    totalReceived: 2086465.5,
                    currentReceived: 105313.7254901961,
                    totalTransmitted: 108605,
                    currentTransmitted: 7189.909872372932,
                },
                userTime: 7.455499999999999,
                timeframe: {
                    end: '2022-01-19T14:25:51.178Z',
                    start: '2022-01-19T14:25:42.016Z',
                },
            },
        ],
    },
    {
        id: 'container_2',
        name: 'Acme API',
        score: {
            s: {
                cpu: 0.20550000000000004,
                screen: 12.7975,
                totalTime: 45.93849999999999,
            },
            gb: {
                mem: 0.7338639360000001,
                disk: 0,
                network: 0.0018178884999999994,
            },
            wh: {
                total: 0.02,
            },
            co2: {
                total: 0.00884,
            },
        },
    },
    {
        id: 'container_3',
        type: 'DATABASE',
        name: 'Acme Database',
        score: {
            wh: {
                total: 0.004,
            },
            co2: {
                total: 0.002,
            },
        },
    },
];
